import type { PublicationWithEditions } from "@/api/researchCms.service";

export type ManageTarget = {
  publicationConfigId: string;
  editionConfigId: string;
};

export function resolveManageTarget(
  publications: PublicationWithEditions[],
  routeEditionId: string | undefined,
): ManageTarget | null {
  if (!routeEditionId) return null;

  for (const publication of publications) {
    const edition = publication.editions.find(candidate => candidate.editionId === routeEditionId);
    if (edition) {
      return { publicationConfigId: publication.id, editionConfigId: edition.id };
    }
  }

  return null;
}
